import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import SnmpUserCreate from './containers/SnmpUserCreate';
import SnmpUserEdit from './containers/SnmpUserEdit';
import SnmpUserList from './containers/SnmpUserList';
import SnmpUserView from './containers/SnmpUserView';
import {
  SYSTEM_CONFIGURATION_ROUTE,
  SECURITY,
  SNMP_USERS
} from '../../constants';

interface Props {}

const SnmpUser: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route
        exact
        path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SNMP_USERS}`}
      >
        <SnmpUserList />
      </Route>
      <Route
        exact
        path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SNMP_USERS}/create`}
      >
        <SnmpUserCreate />
      </Route>
      <Route
        exact
        path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SNMP_USERS}/edit`}
      >
        <SnmpUserEdit />
      </Route>
      <Route
        exact
        path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${SNMP_USERS}/view`}
      >
        <SnmpUserView />
      </Route>
    </Fragment>
  );
};

export default SnmpUser;
